/* tslint:disable */
/* eslint-disable */
/**
 * My Title
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AssetDashboardResponse,
  ConfigurationSyncResponse,
  EquipmentPartResponse,
  FleetSyncResponse,
  HttpValidationProblemDetails,
  InspectionReassignResponse,
  InspectionSyncResponse,
  InspectionsSyncResponse,
  ObservationResponse,
  PartCatalogSyncResponse,
  ReassignInspectionRequest,
  ReferenceDataSyncResponse,
  SaveInspectionsRequest,
  Stream,
} from '../models/index';
import {
    AssetDashboardResponseFromJSON,
    AssetDashboardResponseToJSON,
    ConfigurationSyncResponseFromJSON,
    ConfigurationSyncResponseToJSON,
    EquipmentPartResponseFromJSON,
    EquipmentPartResponseToJSON,
    FleetSyncResponseFromJSON,
    FleetSyncResponseToJSON,
    HttpValidationProblemDetailsFromJSON,
    HttpValidationProblemDetailsToJSON,
    InspectionReassignResponseFromJSON,
    InspectionReassignResponseToJSON,
    InspectionSyncResponseFromJSON,
    InspectionSyncResponseToJSON,
    InspectionsSyncResponseFromJSON,
    InspectionsSyncResponseToJSON,
    ObservationResponseFromJSON,
    ObservationResponseToJSON,
    PartCatalogSyncResponseFromJSON,
    PartCatalogSyncResponseToJSON,
    ReassignInspectionRequestFromJSON,
    ReassignInspectionRequestToJSON,
    ReferenceDataSyncResponseFromJSON,
    ReferenceDataSyncResponseToJSON,
    SaveInspectionsRequestFromJSON,
    SaveInspectionsRequestToJSON,
    StreamFromJSON,
    StreamToJSON,
} from '../models/index';

export interface DownloadFileRequest {
    observationId: number;
}

export interface GetAssetDashboardRequest {
    assetId: number;
}

export interface GetInspectionByExternalIdRequest {
    externalId: string;
}

export interface GetInspectionCatalogRequest {
    lastSyncDate?: Date | null;
    payloadVersion?: number | null;
}

export interface GetInspectionConfigurationRequest {
    lastSyncDate?: Date | null;
    payloadVersion?: number | null;
}

export interface GetInspectionFleetRequest {
    lastSyncDate?: Date | null;
    payloadVersion?: number | null;
}

export interface GetInspectionSyncDetailsRequest {
    lastSyncDate?: Date | null;
    payloadVersion?: number | null;
}

export interface GetInspectionsRequest {
    lastSyncDate?: Date | null;
    payloadVersion?: number | null;
}

export interface ReassignInspectionOperationRequest {
    inspectionId: number;
    reassignInspectionRequest: ReassignInspectionRequest;
}

export interface SaveInspectionsOperationRequest {
    saveInspectionsRequest: SaveInspectionsRequest;
}

export interface StreamInspectionFleetPartsRequest {
    lastSyncDate?: Date | null;
    payloadVersion?: number | null;
}

export interface StreamInspectionSyncObservationsRequest {
    lastSyncDate?: Date | null;
    payloadVersion?: number | null;
}

export interface UploadFileRequest {
    observationId: number;
    observationId2?: number;
    files?: Array<Blob>;
}

/**
 * 
 */
export class InspectionApi extends runtime.BaseAPI {

    /**
     */
    async downloadFileRaw(requestParameters: DownloadFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Stream>> {
        if (requestParameters['observationId'] == null) {
            throw new runtime.RequiredError(
                'observationId',
                'Required parameter "observationId" was null or undefined when calling downloadFile().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/inspection/download/{observationId}`;
        urlPath = urlPath.replace(`{${"observationId"}}`, encodeURIComponent(String(requestParameters['observationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StreamFromJSON(jsonValue));
    }

    /**
     */
    async downloadFile(requestParameters: DownloadFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Stream> {
        const response = await this.downloadFileRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getAssetDashboardRaw(requestParameters: GetAssetDashboardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AssetDashboardResponse>> {
        if (requestParameters['assetId'] == null) {
            throw new runtime.RequiredError(
                'assetId',
                'Required parameter "assetId" was null or undefined when calling getAssetDashboard().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/inspection/asset/{assetId}/dashboard`;
        urlPath = urlPath.replace(`{${"assetId"}}`, encodeURIComponent(String(requestParameters['assetId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AssetDashboardResponseFromJSON(jsonValue));
    }

    /**
     */
    async getAssetDashboard(requestParameters: GetAssetDashboardRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AssetDashboardResponse> {
        const response = await this.getAssetDashboardRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getInspectionByExternalIdRaw(requestParameters: GetInspectionByExternalIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InspectionSyncResponse>> {
        if (requestParameters['externalId'] == null) {
            throw new runtime.RequiredError(
                'externalId',
                'Required parameter "externalId" was null or undefined when calling getInspectionByExternalId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/inspection/{externalId}`;
        urlPath = urlPath.replace(`{${"externalId"}}`, encodeURIComponent(String(requestParameters['externalId'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InspectionSyncResponseFromJSON(jsonValue));
    }

    /**
     */
    async getInspectionByExternalId(requestParameters: GetInspectionByExternalIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InspectionSyncResponse> {
        const response = await this.getInspectionByExternalIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getInspectionCatalogRaw(requestParameters: GetInspectionCatalogRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PartCatalogSyncResponse>> {
        const queryParameters: any = {};

        if (requestParameters['lastSyncDate'] != null) {
            queryParameters['LastSyncDate'] = (requestParameters['lastSyncDate'] as any).toISOString();
        }

        if (requestParameters['payloadVersion'] != null) {
            queryParameters['PayloadVersion'] = requestParameters['payloadVersion'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/inspection/catalog`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PartCatalogSyncResponseFromJSON(jsonValue));
    }

    /**
     */
    async getInspectionCatalog(requestParameters: GetInspectionCatalogRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PartCatalogSyncResponse> {
        const response = await this.getInspectionCatalogRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getInspectionConfigurationRaw(requestParameters: GetInspectionConfigurationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ConfigurationSyncResponse>> {
        const queryParameters: any = {};

        if (requestParameters['lastSyncDate'] != null) {
            queryParameters['LastSyncDate'] = (requestParameters['lastSyncDate'] as any).toISOString();
        }

        if (requestParameters['payloadVersion'] != null) {
            queryParameters['PayloadVersion'] = requestParameters['payloadVersion'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/inspection/configuration`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ConfigurationSyncResponseFromJSON(jsonValue));
    }

    /**
     */
    async getInspectionConfiguration(requestParameters: GetInspectionConfigurationRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ConfigurationSyncResponse> {
        const response = await this.getInspectionConfigurationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getInspectionFleetRaw(requestParameters: GetInspectionFleetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FleetSyncResponse>> {
        const queryParameters: any = {};

        if (requestParameters['lastSyncDate'] != null) {
            queryParameters['LastSyncDate'] = (requestParameters['lastSyncDate'] as any).toISOString();
        }

        if (requestParameters['payloadVersion'] != null) {
            queryParameters['PayloadVersion'] = requestParameters['payloadVersion'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/inspection/fleet`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FleetSyncResponseFromJSON(jsonValue));
    }

    /**
     */
    async getInspectionFleet(requestParameters: GetInspectionFleetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FleetSyncResponse> {
        const response = await this.getInspectionFleetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getInspectionReferenceDataRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ReferenceDataSyncResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/inspection/reference-data`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReferenceDataSyncResponseFromJSON(jsonValue));
    }

    /**
     */
    async getInspectionReferenceData(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ReferenceDataSyncResponse> {
        const response = await this.getInspectionReferenceDataRaw(initOverrides);
        return await response.value();
    }

    /**
     */
    async getInspectionSyncDetailsRaw(requestParameters: GetInspectionSyncDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InspectionSyncResponse>> {
        const queryParameters: any = {};

        if (requestParameters['lastSyncDate'] != null) {
            queryParameters['LastSyncDate'] = (requestParameters['lastSyncDate'] as any).toISOString();
        }

        if (requestParameters['payloadVersion'] != null) {
            queryParameters['PayloadVersion'] = requestParameters['payloadVersion'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/inspection/sync`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InspectionSyncResponseFromJSON(jsonValue));
    }

    /**
     */
    async getInspectionSyncDetails(requestParameters: GetInspectionSyncDetailsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InspectionSyncResponse> {
        const response = await this.getInspectionSyncDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getInspectionsRaw(requestParameters: GetInspectionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InspectionsSyncResponse>> {
        const queryParameters: any = {};

        if (requestParameters['lastSyncDate'] != null) {
            queryParameters['LastSyncDate'] = (requestParameters['lastSyncDate'] as any).toISOString();
        }

        if (requestParameters['payloadVersion'] != null) {
            queryParameters['PayloadVersion'] = requestParameters['payloadVersion'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/inspections`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InspectionsSyncResponseFromJSON(jsonValue));
    }

    /**
     */
    async getInspections(requestParameters: GetInspectionsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InspectionsSyncResponse> {
        const response = await this.getInspectionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async reassignInspectionRaw(requestParameters: ReassignInspectionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InspectionReassignResponse>> {
        if (requestParameters['inspectionId'] == null) {
            throw new runtime.RequiredError(
                'inspectionId',
                'Required parameter "inspectionId" was null or undefined when calling reassignInspection().'
            );
        }

        if (requestParameters['reassignInspectionRequest'] == null) {
            throw new runtime.RequiredError(
                'reassignInspectionRequest',
                'Required parameter "reassignInspectionRequest" was null or undefined when calling reassignInspection().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/inspection/{inspectionId}/reassign`;
        urlPath = urlPath.replace(`{${"inspectionId"}}`, encodeURIComponent(String(requestParameters['inspectionId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ReassignInspectionRequestToJSON(requestParameters['reassignInspectionRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InspectionReassignResponseFromJSON(jsonValue));
    }

    /**
     */
    async reassignInspection(requestParameters: ReassignInspectionOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InspectionReassignResponse> {
        const response = await this.reassignInspectionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async saveInspectionsRaw(requestParameters: SaveInspectionsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<InspectionSyncResponse>> {
        if (requestParameters['saveInspectionsRequest'] == null) {
            throw new runtime.RequiredError(
                'saveInspectionsRequest',
                'Required parameter "saveInspectionsRequest" was null or undefined when calling saveInspections().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/inspection`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SaveInspectionsRequestToJSON(requestParameters['saveInspectionsRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InspectionSyncResponseFromJSON(jsonValue));
    }

    /**
     */
    async saveInspections(requestParameters: SaveInspectionsOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<InspectionSyncResponse> {
        const response = await this.saveInspectionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async streamInspectionFleetPartsRaw(requestParameters: StreamInspectionFleetPartsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<EquipmentPartResponse>>> {
        const queryParameters: any = {};

        if (requestParameters['lastSyncDate'] != null) {
            queryParameters['LastSyncDate'] = (requestParameters['lastSyncDate'] as any).toISOString();
        }

        if (requestParameters['payloadVersion'] != null) {
            queryParameters['PayloadVersion'] = requestParameters['payloadVersion'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/inspection/fleet/parts`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(EquipmentPartResponseFromJSON));
    }

    /**
     */
    async streamInspectionFleetParts(requestParameters: StreamInspectionFleetPartsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<EquipmentPartResponse>> {
        const response = await this.streamInspectionFleetPartsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async streamInspectionSyncObservationsRaw(requestParameters: StreamInspectionSyncObservationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ObservationResponse>>> {
        const queryParameters: any = {};

        if (requestParameters['lastSyncDate'] != null) {
            queryParameters['LastSyncDate'] = (requestParameters['lastSyncDate'] as any).toISOString();
        }

        if (requestParameters['payloadVersion'] != null) {
            queryParameters['PayloadVersion'] = requestParameters['payloadVersion'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/inspection/sync/observations`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ObservationResponseFromJSON));
    }

    /**
     */
    async streamInspectionSyncObservations(requestParameters: StreamInspectionSyncObservationsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ObservationResponse>> {
        const response = await this.streamInspectionSyncObservationsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async uploadFileRaw(requestParameters: UploadFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['observationId'] == null) {
            throw new runtime.RequiredError(
                'observationId',
                'Required parameter "observationId" was null or undefined when calling uploadFile().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['observationId2'] != null) {
            formParams.append('observationId', requestParameters['observationId2'] as any);
        }

        if (requestParameters['files'] != null) {
            requestParameters['files'].forEach((element) => {
                formParams.append('files', element as any);
            })
        }


        let urlPath = `/inspection/upload/{observationId}`;
        urlPath = urlPath.replace(`{${"observationId"}}`, encodeURIComponent(String(requestParameters['observationId'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async uploadFile(requestParameters: UploadFileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.uploadFileRaw(requestParameters, initOverrides);
    }

}
